import { Box, Text } from '@factorialco/deprecated-design-system'
import { Field } from 'factorial-form'

import { observer } from 'mobx-react'

import { useCurrentAccessWeekdays } from 'modules/core/hooks/useCurrentAccessWeekdays'
import i18n from 'modules/core/lib/i18n'

export interface Props {
  field: Field
  readonly?: boolean
  canUnselectAll?: boolean
}

const getWorkDaysLabel = (type: string) => {
  switch (type) {
    case 'friday':
      return i18n.t('shift_management.actions_sidepanel.time_period.custom_days_selector.friday')
    case 'monday':
      return i18n.t('shift_management.actions_sidepanel.time_period.custom_days_selector.monday')
    case 'saturday':
      return i18n.t('shift_management.actions_sidepanel.time_period.custom_days_selector.saturday')
    case 'sunday':
      return i18n.t('shift_management.actions_sidepanel.time_period.custom_days_selector.sunday')
    case 'thursday':
      return i18n.t('shift_management.actions_sidepanel.time_period.custom_days_selector.thursday')
    case 'tuesday':
      return i18n.t('shift_management.actions_sidepanel.time_period.custom_days_selector.tuesday')
    case 'wednesday':
      return i18n.t('shift_management.actions_sidepanel.time_period.custom_days_selector.wednesday')
    default:
      throw new Error(`Unknown translation for type: ${type}`)
  }
}

const CustomDaysSelector = ({ field, readonly, canUnselectAll }: Props) => {
  const weekDays = useCurrentAccessWeekdays()

  const select = (day: string) => {
    if (readonly) return

    const selectedDays: string[] = field.value ? field.value.split(',') : []
    const index = selectedDays.findIndex((d) => d === day)

    if (index > -1) {
      if (!canUnselectAll && selectedDays.length === 1) return

      selectedDays.splice(index, 1)

      if (!selectedDays.length) {
        return field.set('')
      }

      return field.set(selectedDays.join(','))
    }

    field.set(selectedDays.concat([day]).join(','))
  }

  const selectedDays = field.value.split(',')

  return (
    <Box
      padding="s16"
      gap="s8"
      background="grey100"
      borderRadius={{ all: 'abs016' }}
      border={{ all: { width: 's1', color: 'grey300', style: 'solid' } }}
    >
      <Text.Normal size="200" weight="medium" color="grey800">
        {i18n.t('shift_management.actions_sidepanel.time_period.repeats_on')}:
      </Text.Normal>
      <Box flexDirection="row" gap="s8">
        {weekDays.map((day) => {
          const shortDay = getWorkDaysLabel(day ?? '')
          const isSelected = selectedDays.includes(day)

          return (
            <Box
              minWidth="s24"
              minHeight="s24"
              textAlign="center"
              background={isSelected ? 'viridian1000' : 'viridian100'}
              borderRadius={{ all: 'abs004' }}
              onClick={() => select(day)}
              key={day}
            >
              <Text.Normal color={isSelected ? 'white' : 'grey800'}>{shortDay}</Text.Normal>
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}

export default observer(CustomDaysSelector)
